import React, { useEffect } from "react";
import '../index.scss';
import '../generalContainer.scss';
import './index.scss';
import Contacts from "../../contacts";
import HeaderContainer from "../header/";

const HeaderNavContact = () => {
    useEffect(() => {
        const handleScroll = () => {
            const AltoPantalla = window.innerHeight;
            const Elemento = document.getElementById("PaginaFooter");
            const Elemento2 = document.getElementById("containerFormContact");
            const Elemento3 = document.getElementById("containerFormContactMovil");

            if (window.scrollY > 0) {
                if (window.innerWidth > 700) {
                    const porcentaje = ((100 / (AltoPantalla / 4)) * window.scrollY) / 100;
                    if (Elemento) Elemento.style.backgroundColor = `rgba(290, 80, 15, ${porcentaje})`;
                    if (Elemento2) Elemento2.style.backgroundColor = `rgba(290, 80, 15, ${porcentaje})`;
                    if (Elemento3) Elemento3.style.backgroundColor = `rgba(290, 80, 15, ${porcentaje})`;
                }

                if (window.innerWidth < 700) {
                    const porcentaje = ((100 / AltoPantalla) * (window.scrollY / 1.8)) / 100;
                    if (Elemento) Elemento.style.backgroundColor = `rgba(290, 80, 15, ${porcentaje})`;
                    if (Elemento2) Elemento2.style.backgroundColor = `rgba(290, 80, 15, ${porcentaje})`;
                    if (Elemento3) Elemento3.style.backgroundColor = `rgba(290, 80, 15, ${porcentaje})`;
                }

                if (window.innerWidth < 390) {
                    const porcentaje = ((100 / (AltoPantalla / 0.5)) * (window.scrollY / 1.5)) / 100;
                    if (Elemento) Elemento.style.backgroundColor = `rgba(290, 80, 15, ${porcentaje})`;
                    if (Elemento2) Elemento2.style.backgroundColor = `rgba(290, 80, 15, ${porcentaje})`;
                    if (Elemento3) Elemento3.style.backgroundColor = `rgba(290, 80, 15, ${porcentaje})`;
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div id='ContactPage'>
            <HeaderContainer name='normal' />
            <div className="containerProjects" style={{ backgroundColor: "transparent" }}>
                <Contacts />
            </div>
        </div>
    );
};

export default HeaderNavContact;
